import { useEffect, useRef } from 'react';
import { useBreadcrumbs } from '../providers/breadcrumbs/BreadcrumbContext';

/**
 * Hook for pages to register a UID and its corresponding ref for breadcrumb display
 * @param uid - The UID from the URL
 * @param ref - The user-friendly ref to display instead of the UID
 */
export const useBreadcrumbAlias = (uid?: string, ref?: string) => {
  const { setUidRef, setUidLoading } = useBreadcrumbs();
  const lastRef = useRef<string>('');

  useEffect(() => {
    if (uid) {
      if (ref && ref !== lastRef.current) {
        // We have both uid and ref, set the mapping
        lastRef.current = ref;
        setUidRef(uid, ref);
      } else if (!ref) {
        // We have uid but no ref, set loading state
        setUidLoading(uid, true);
      }
    }
  }, [uid, ref, setUidRef, setUidLoading]);

  return {
    setUidRef,
    setUidLoading,
  };
};
